import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  projectCardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: '8px',
  },
  sentNotificationsLink: {
    cursor: 'pointer',
  },
});
